var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.34709 13.9593C2.73709 14.5193 3.42709 14.8393 4.21709 14.8393H8.31709C8.58709 14.8393 8.83709 14.9493 9.00709 15.1493C9.18709 15.3493 9.25709 15.6293 9.21709 15.9193L8.70709 19.1993C8.48709 20.1793 9.13709 21.2793 10.1171 21.6093C11.0271 21.9493 12.0971 21.4893 12.5271 20.8393L16.7371 14.5693L16.8571 14.3693V5.5293L16.7071 5.3793L13.5371 2.9293C13.1171 2.5093 12.1671 2.2793 11.4971 2.2793H7.59709C6.25709 2.2793 4.90709 3.2893 4.60709 4.5193L2.14709 12.0093C1.89709 12.7193 1.96709 13.4193 2.34709 13.9593Z",
    fill: "#DC2626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7894 17.6104H19.8194C21.3694 17.6104 21.9994 17.0104 21.9994 15.5304V5.48039C21.9994 4.00039 21.3694 3.40039 19.8194 3.40039H18.7894C17.2394 3.40039 16.6094 4.00039 16.6094 5.48039V15.5404C16.6094 17.0104 17.2394 17.6104 18.7894 17.6104Z",
    fill: "#DC2626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/ThumbDown.271483ff6af69068e1671cb46d8824c0.svg";
export { ForwardRef as ReactComponent };